
import React  from "react";
import './Liveaction.css';
import { Container ,  Row ,Col } from "reactstrap";
import { Link } from "react-router-dom";

import Nftcards from "../Nftards/Nftcards";
import { NFT__DATA } from './../../../assets/data/data';



function  Liveaction  ()  {
    return (
        <section className="">
            <Container>
                <Row>
                    <Col lg='12 '  className="mb-5"  >
                        <div className="live__auction__top  d-flex   align-items-center  justify-content-between">
                            <h3> live Auction  </h3>
                            <span> <Link  to='/market'> Explore More </Link> </span>
                        </div>
                    </Col>

                        {
                            NFT__DATA.slice(0,4).map((item) => {
                                return(
                                    <Col  lg="3"  md="4" sm="6"  className="mb-4">
                                        <Nftcards key={item.id} item={item}  />
                                    </Col>
                                )
                            })
                        }
                        
                
                </Row>
            </Container>
            
        </section>
    );
}

export default  Liveaction;

